<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  collegeComputed,
  authComputed,
  collegeListMethod,
  siteListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Add College',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      name: '',
      collegeCode: '',
      collegeError: null,
      collegeDataStatus: false,
      isCollegeError: false,
      isLoading: false,
      show: false,
      platformId: 0,
      siteconfiglist: [],
    }
  },
  computed: {
    ...collegeComputed,
    ...authComputed,
  },
  mounted() {
    if (this.role === 'admin') {
      this.getListOfPlatform()
    } else {
      this.platformId = this.currentUser.user.platform_id
    }
  },
  methods: {
    ...collegeListMethod,
    ...siteListMethod,

    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          // listitems.push({value:'All', text: 'All'})
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },
    // save college method
    saveCollege() {
      const Data = {
        name: this.name,
        collegeCode: this.collegeCode,
        platform_id: this.platformId,
      }

      this.addCollegeData({ Data })
        .then((college) => {
          this.isLoading = false
          this.$router.push({ name: 'college.list' })
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.collegeError = getError.message
          this.isCollegeError = true
          window.scrollTo(0, 0)
        })
    },
    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.collegeCode.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isCollegeError"
              variant="danger"
              v-html="collegeError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="saveCollege"
            >
              <b-form-group
                v-if="role === 'admin'"
                label="Select Platform*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="platformId"
                  :options="siteconfiglist"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="College Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="name"
                  type="text"
                  placeholder="Enter College Name"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="College Code*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="collegeCode"
                  type="text"
                  placeholder="Enter College Code"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/college-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
</style>
